import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import Hint from '../../Hint/Hint.js';
import BaseBreadcrumbOption from './BaseBreadcrumbOption.js';

const _BaseBreadcrumbOption = styled(BaseBreadcrumbOption) `
  ${({ highlighted, theme }) => highlighted &&
    `#label {
      color: ${theme.palette.N05.main};
    }`}
`;
const BreadcrumbOption = (_a) => {
    var { hint, id, highlighted } = _a, rest = __rest(_a, ["hint", "id", "highlighted"]);
    return (jsx(Hint, Object.assign({ title: hint }, { children: jsx(_BaseBreadcrumbOption, Object.assign({ highlighted: highlighted, "data-testid": `breadcrumb-${id}` }, rest)) })));
};

export { BreadcrumbOption as default };
//# sourceMappingURL=BreadcrumbOption.js.map
